// VIP Gallery - Artworks Data v3
// Premium art gallery data structure

export const artworks = [
  {
    id: 1,
    title: {
      ru: "Утренний свет",
      en: "Morning Light"
    },
    year: 2024,
    technique: {
      ru: "Холст, масло",
      en: "Oil on canvas"
    },
    size: "80 x 100 cm",
    status: "available",
    price: 3500,
    priceRange: "$$",
    category: "landscape",
    series: "light",
    dominantColor: "warm",
    mood: "peaceful",
    featured: true,
    image: "/images/1.jpeg",
    images: ["/images/1.jpeg"],
    description: {
      ru: "Работа передает тонкую игру утреннего света, проникающего сквозь туманную дымку. Мягкие золотистые тона создают атмосферу умиротворения.",
      en: "This work conveys the subtle play of morning light filtering through the misty haze. Soft golden tones create an atmosphere of tranquility."
    },
    certificate: true,
    framed: false,
    unique: true
  },
  {
    id: 2,
    title: {
      ru: "Городские отражения",
      en: "Urban Reflections"
    },
    year: 2024,
    technique: {
      ru: "Холст, акрил",
      en: "Acrylic on canvas"
    },
    size: "60 x 80 cm",
    status: "available",
    price: 2800,
    priceRange: "$$",
    category: "urban",
    series: "city",
    dominantColor: "cool",
    mood: "dynamic",
    featured: true,
    image: "/images/2.jpeg",
    images: ["/images/2.jpeg"],
    description: {
      ru: "Городской пейзаж, запечатлевший момент между днем и ночью. Неоновые огни отражаются в мокром асфальте.",
      en: "An urban landscape capturing the moment between day and night. Neon lights reflect on wet asphalt."
    },
    certificate: true,
    framed: true,
    unique: true
  },
  {
    id: 3,
    title: {
      ru: "Тишина сада",
      en: "Garden Silence"
    },
    year: 2023,
    technique: {
      ru: "Холст, масло",
      en: "Oil on canvas"
    },
    size: "100 x 120 cm",
    status: "sold",
    price: null,
    priceRange: "$$$",
    category: "garden",
    series: "nature",
    dominantColor: "green",
    mood: "peaceful",
    featured: true,
    image: "/images/3.jpeg",
    images: ["/images/3.jpeg"],
    description: {
      ru: "Уединенный уголок сада, где время замедляет свой ход. Работа из частной коллекции.",
      en: "A secluded garden corner where time slows down. Work from a private collection."
    },
    certificate: true,
    framed: true,
    unique: true
  },
  {
    id: 4,
    title: {
      ru: "Морской бриз",
      en: "Sea Breeze"
    },
    year: 2024,
    technique: {
      ru: "Холст, масло",
      en: "Oil on canvas"
    },
    size: "70 x 90 cm",
    status: "available",
    price: 3200,
    priceRange: "$$",
    category: "landscape",
    series: "water",
    dominantColor: "blue",
    mood: "refreshing",
    featured: false,
    image: "/images/4.jpeg",
    images: ["/images/4.jpeg"],
    description: {
      ru: "Свежесть морского воздуха и бесконечность горизонта. Работа создает ощущение свободы.",
      en: "The freshness of sea air and the infinity of the horizon. This work creates a sense of freedom."
    },
    certificate: true,
    framed: false,
    unique: true
  },
  {
    id: 5,
    title: {
      ru: "Осенняя симфония",
      en: "Autumn Symphony"
    },
    year: 2023,
    technique: {
      ru: "Холст, масло",
      en: "Oil on canvas"
    },
    size: "90 x 110 cm",
    status: "reserved",
    price: 4200,
    priceRange: "$$$",
    category: "landscape",
    series: "seasons",
    dominantColor: "warm",
    mood: "nostalgic",
    featured: true,
    image: "/images/5.jpeg",
    images: ["/images/5.jpeg"],
    description: {
      ru: "Богатство осенних красок, от золотисто-желтого до глубокого бордового. Гимн уходящему теплу.",
      en: "The richness of autumn colors, from golden yellow to deep burgundy. A hymn to departing warmth."
    },
    certificate: true,
    framed: true,
    unique: true
  },
  {
    id: 6,
    title: {
      ru: "Ночной город",
      en: "Night City"
    },
    year: 2024,
    technique: {
      ru: "Холст, акрил",
      en: "Acrylic on canvas"
    },
    size: "80 x 100 cm",
    status: "available",
    price: 3800,
    priceRange: "$$$",
    category: "urban",
    series: "city",
    dominantColor: "dark",
    mood: "mysterious",
    featured: false,
    image: "/images/6.jpeg",
    images: ["/images/6.jpeg"],
    description: {
      ru: "Город никогда не спит. Работа исследует магию ночных огней и теней.",
      en: "The city never sleeps. This work explores the magic of night lights and shadows."
    },
    certificate: true,
    framed: false,
    unique: true
  },
  {
    id: 7,
    title: {
      ru: "Цветущий май",
      en: "Blooming May"
    },
    year: 2023,
    technique: {
      ru: "Холст, масло",
      en: "Oil on canvas"
    },
    size: "60 x 70 cm",
    status: "available",
    price: 2200,
    priceRange: "$",
    category: "garden",
    series: "seasons",
    dominantColor: "pink",
    mood: "joyful",
    featured: false,
    image: "/images/7.jpeg",
    images: ["/images/7.jpeg"],
    description: {
      ru: "Буйство весеннего цветения. Яблоневый сад в разгар мая.",
      en: "The exuberance of spring bloom. An apple orchard in the midst of May."
    },
    certificate: true,
    framed: true,
    unique: true
  },
  {
    id: 8,
    title: {
      ru: "Горный рассвет",
      en: "Mountain Dawn"
    },
    year: 2024,
    technique: {
      ru: "Холст, масло",
      en: "Oil on canvas"
    },
    size: "120 x 150 cm",
    status: "available",
    price: 6500,
    priceRange: "$$$$",
    category: "landscape",
    series: "light",
    dominantColor: "purple",
    mood: "majestic",
    featured: true,
    image: "/images/8.jpeg",
    images: ["/images/8.jpeg"],
    description: {
      ru: "Величие горных вершин в первых лучах солнца. Большой формат для интерьеров.",
      en: "The majesty of mountain peaks in the first rays of the sun. Large format for interiors."
    },
    certificate: true,
    framed: false,
    unique: true
  },
  {
    id: 9,
    title: {
      ru: "Полуденный зной",
      en: "Midday Heat"
    },
    year: 2023,
    technique: {
      ru: "Холст, масло",
      en: "Oil on canvas"
    },
    size: "70 x 80 cm",
    status: "sold",
    price: null,
    priceRange: "$$",
    category: "landscape",
    series: "seasons",
    dominantColor: "warm",
    mood: "contemplative",
    featured: false,
    image: "/images/9.jpeg",
    images: ["/images/9.jpeg"],
    description: {
      ru: "Летний полдень, когда все замирает в ожидании прохлады. Частная коллекция.",
      en: "A summer afternoon when everything stands still waiting for coolness. Private collection."
    },
    certificate: true,
    framed: true,
    unique: true
  },
  {
    id: 10,
    title: {
      ru: "Первый снег",
      en: "First Snow"
    },
    year: 2024,
    technique: {
      ru: "Холст, масло",
      en: "Oil on canvas"
    },
    size: "80 x 100 cm",
    status: "available",
    price: 3400,
    priceRange: "$$",
    category: "landscape",
    series: "seasons",
    dominantColor: "white",
    mood: "peaceful",
    featured: false,
    image: "/images/10.jpeg",
    images: ["/images/10.jpeg"],
    description: {
      ru: "Магия первого снегопада, когда мир преображается в одночасье.",
      en: "The magic of the first snowfall, when the world transforms overnight."
    },
    certificate: true,
    framed: false,
    unique: true
  },
  {
    id: 11,
    title: {
      ru: "Вечерний чай",
      en: "Evening Tea"
    },
    year: 2023,
    technique: {
      ru: "Холст, масло",
      en: "Oil on canvas"
    },
    size: "50 x 60 cm",
    status: "available",
    price: 1800,
    priceRange: "$",
    category: "stilllife",
    series: "moments",
    dominantColor: "warm",
    mood: "cozy",
    featured: false,
    image: "/images/11.jpeg",
    images: ["/images/11.jpeg"],
    description: {
      ru: "Интимный натюрморт с чайным сервизом. Тепло домашнего уюта.",
      en: "An intimate still life with a tea set. The warmth of home comfort."
    },
    certificate: true,
    framed: true,
    unique: true
  },
  {
    id: 12,
    title: {
      ru: "Закат над полем",
      en: "Sunset Over the Field"
    },
    year: 2024,
    technique: {
      ru: "Холст, масло",
      en: "Oil on canvas"
    },
    size: "100 x 130 cm",
    status: "available",
    price: 5200,
    priceRange: "$$$",
    category: "landscape",
    series: "light",
    dominantColor: "orange",
    mood: "dramatic",
    featured: true,
    image: "/images/12.jpeg",
    images: ["/images/12.jpeg"],
    description: {
      ru: "Драматичный закат, окрашивающий пшеничное поле в огненные тона.",
      en: "A dramatic sunset painting a wheat field in fiery tones."
    },
    certificate: true,
    framed: false,
    unique: true
  },
  {
    id: 13,
    title: {
      ru: "Старый город",
      en: "Old Town"
    },
    year: 2023,
    technique: {
      ru: "Холст, акрил",
      en: "Acrylic on canvas"
    },
    size: "70 x 90 cm",
    status: "available",
    price: 2900,
    priceRange: "$$",
    category: "urban",
    series: "city",
    dominantColor: "neutral",
    mood: "nostalgic",
    featured: false,
    image: "/images/13.jpeg",
    images: ["/images/13.jpeg"],
    description: {
      ru: "Узкие улочки старого города, где каждый камень хранит историю.",
      en: "Narrow streets of the old town, where every stone holds a story."
    },
    certificate: true,
    framed: true,
    unique: true
  },
  {
    id: 14,
    title: {
      ru: "Лесное озеро",
      en: "Forest Lake"
    },
    year: 2024,
    technique: {
      ru: "Холст, масло",
      en: "Oil on canvas"
    },
    size: "90 x 120 cm",
    status: "available",
    price: 4500,
    priceRange: "$$$",
    category: "landscape",
    series: "water",
    dominantColor: "green",
    mood: "serene",
    featured: false,
    image: "/images/14.jpeg",
    images: ["/images/14.jpeg"],
    description: {
      ru: "Зеркальная гладь лесного озера, отражающая небо и деревья.",
      en: "The mirror surface of a forest lake, reflecting the sky and trees."
    },
    certificate: true,
    framed: false,
    unique: true
  },
  {
    id: 15,
    title: {
      ru: "Весенний букет",
      en: "Spring Bouquet"
    },
    year: 2023,
    technique: {
      ru: "Холст, масло",
      en: "Oil on canvas"
    },
    size: "60 x 80 cm",
    status: "sold",
    price: null,
    priceRange: "$$",
    category: "stilllife",
    series: "flowers",
    dominantColor: "multicolor",
    mood: "joyful",
    featured: false,
    image: "/images/15.jpeg",
    images: ["/images/15.jpeg"],
    description: {
      ru: "Яркий букет полевых цветов, символ весеннего пробуждения.",
      en: "A bright bouquet of wildflowers, a symbol of spring awakening."
    },
    certificate: true,
    framed: true,
    unique: true
  },
  {
    id: 16,
    title: {
      ru: "Туманное утро",
      en: "Foggy Morning"
    },
    year: 2024,
    technique: {
      ru: "Холст, масло",
      en: "Oil on canvas"
    },
    size: "80 x 100 cm",
    status: "available",
    price: 3600,
    priceRange: "$$",
    category: "landscape",
    series: "light",
    dominantColor: "grey",
    mood: "mysterious",
    featured: false,
    image: "/images/16.jpeg",
    images: ["/images/16.jpeg"],
    description: {
      ru: "Мир, окутанный туманом, где реальность и мечта сливаются воедино.",
      en: "A world shrouded in mist, where reality and dream merge into one."
    },
    certificate: true,
    framed: false,
    unique: true
  },
  {
    id: 17,
    title: {
      ru: "Подсолнухи",
      en: "Sunflowers"
    },
    year: 2023,
    technique: {
      ru: "Холст, масло",
      en: "Oil on canvas"
    },
    size: "70 x 90 cm",
    status: "available",
    price: 2800,
    priceRange: "$$",
    category: "stilllife",
    series: "flowers",
    dominantColor: "yellow",
    mood: "cheerful",
    featured: false,
    image: "/images/17.jpeg",
    images: ["/images/17.jpeg"],
    description: {
      ru: "Солнечные цветы, наполняющие пространство теплом и радостью.",
      en: "Sunny flowers that fill the space with warmth and joy."
    },
    certificate: true,
    framed: true,
    unique: true
  },
  {
    id: 18,
    title: {
      ru: "Вечерняя прогулка",
      en: "Evening Walk"
    },
    year: 2024,
    technique: {
      ru: "Холст, акрил",
      en: "Acrylic on canvas"
    },
    size: "60 x 80 cm",
    status: "available",
    price: 2400,
    priceRange: "$",
    category: "urban",
    series: "city",
    dominantColor: "blue",
    mood: "romantic",
    featured: false,
    image: "/images/18.jpeg",
    images: ["/images/18.jpeg"],
    description: {
      ru: "Романтика вечернего города, освещенного фонарями.",
      en: "The romance of an evening city lit by lanterns."
    },
    certificate: true,
    framed: false,
    unique: true
  },
  {
    id: 19,
    title: {
      ru: "Зимний лес",
      en: "Winter Forest"
    },
    year: 2024,
    technique: {
      ru: "Холст, масло",
      en: "Oil on canvas"
    },
    size: "90 x 110 cm",
    status: "available",
    price: 4000,
    priceRange: "$$$",
    category: "landscape",
    series: "seasons",
    dominantColor: "white",
    mood: "peaceful",
    featured: false,
    image: "/images/19.jpeg",
    images: ["/images/19.jpeg"],
    description: {
      ru: "Безмолвие заснеженного леса, где каждая ветка покрыта инеем.",
      en: "The silence of a snow-covered forest, where every branch is covered with frost."
    },
    certificate: true,
    framed: true,
    unique: true
  }
];

// Collections / Series
export const collections = [
  {
    id: "light",
    title: { ru: "Игра света", en: "Play of Light" },
    description: {
      ru: "Серия работ, исследующих природу света и его взаимодействие с окружающим миром",
      en: "A series of works exploring the nature of light and its interaction with the surrounding world"
    }
  },
  {
    id: "seasons",
    title: { ru: "Времена года", en: "Seasons" },
    description: {
      ru: "Цикл работ, посвященный красоте каждого сезона",
      en: "A cycle of works dedicated to the beauty of each season"
    }
  },
  {
    id: "city",
    title: { ru: "Городские мотивы", en: "Urban Motifs" },
    description: {
      ru: "Архитектура и атмосфера городской жизни",
      en: "Architecture and atmosphere of urban life"
    }
  },
  {
    id: "water",
    title: { ru: "Водные мотивы", en: "Water Themes" },
    description: {
      ru: "Море, озера, реки - вечная тема в искусстве",
      en: "Sea, lakes, rivers - an eternal theme in art"
    }
  },
  {
    id: "flowers",
    title: { ru: "Цветы", en: "Flowers" },
    description: {
      ru: "Красота живых цветов в классической традиции",
      en: "The beauty of living flowers in the classical tradition"
    }
  },
  {
    id: "moments",
    title: { ru: "Моменты жизни", en: "Life Moments" },
    description: {
      ru: "Натюрморты, запечатлевшие мимолетные мгновения",
      en: "Still lifes capturing fleeting moments"
    }
  },
  {
    id: "nature",
    title: { ru: "Природа", en: "Nature" },
    description: {
      ru: "Гармония природного мира",
      en: "Harmony of the natural world"
    }
  }
];

// Curated views
export const curatedViews = [
  {
    id: "featured",
    title: { ru: "Избранное", en: "Featured" },
    filter: (artwork) => artwork.featured
  },
  {
    id: "new",
    title: { ru: "Новые работы", en: "New Works" },
    filter: (artwork) => artwork.year === 2024
  },
  {
    id: "available",
    title: { ru: "Доступны к продаже", en: "Available" },
    filter: (artwork) => artwork.status === "available"
  },
  {
    id: "large",
    title: { ru: "Большие форматы", en: "Large Formats" },
    filter: (artwork) => {
      const width = parseInt(artwork.size.split(" x ")[0]);
      return width >= 100;
    }
  },
  {
    id: "interiors",
    title: { ru: "Для интерьеров", en: "For Interiors" },
    filter: (artwork) => artwork.mood === "peaceful" || artwork.mood === "serene"
  }
];

// Categories
export const categories = [
  { id: "all", title: { ru: "Все работы", en: "All Works" } },
  { id: "landscape", title: { ru: "Пейзажи", en: "Landscapes" } },
  { id: "urban", title: { ru: "Городские сцены", en: "Urban Scenes" } },
  { id: "stilllife", title: { ru: "Натюрморты", en: "Still Life" } },
  { id: "garden", title: { ru: "Сады и цветы", en: "Gardens & Flowers" } }
];

// Filters configuration
export const filterOptions = {
  status: [
    { id: "all", title: { ru: "Все", en: "All" } },
    { id: "available", title: { ru: "Доступны", en: "Available" } },
    { id: "sold", title: { ru: "Проданы", en: "Sold" } },
    { id: "reserved", title: { ru: "Зарезервированы", en: "Reserved" } }
  ],
  priceRange: [
    { id: "all", title: { ru: "Любая цена", en: "Any Price" } },
    { id: "$", title: { ru: "До 2 500 EUR", en: "Under 2,500 EUR" } },
    { id: "$$", title: { ru: "2 500 - 4 000 EUR", en: "2,500 - 4,000 EUR" } },
    { id: "$$$", title: { ru: "4 000 - 6 000 EUR", en: "4,000 - 6,000 EUR" } },
    { id: "$$$$", title: { ru: "От 6 000 EUR", en: "From 6,000 EUR" } }
  ],
  year: [
    { id: "all", title: { ru: "Любой год", en: "Any Year" } },
    { id: "2024", title: { ru: "2024", en: "2024" } },
    { id: "2023", title: { ru: "2023", en: "2023" } }
  ],
  mood: [
    { id: "all", title: { ru: "Любое настроение", en: "Any Mood" } },
    { id: "peaceful", title: { ru: "Умиротворенное", en: "Peaceful" } },
    { id: "dynamic", title: { ru: "Динамичное", en: "Dynamic" } },
    { id: "romantic", title: { ru: "Романтичное", en: "Romantic" } },
    { id: "mysterious", title: { ru: "Загадочное", en: "Mysterious" } },
    { id: "joyful", title: { ru: "Радостное", en: "Joyful" } }
  ],
  dominantColor: [
    { id: "all", title: { ru: "Любой цвет", en: "Any Color" } },
    { id: "warm", title: { ru: "Теплые тона", en: "Warm Tones" } },
    { id: "cool", title: { ru: "Холодные тона", en: "Cool Tones" } },
    { id: "green", title: { ru: "Зеленый", en: "Green" } },
    { id: "blue", title: { ru: "Синий", en: "Blue" } },
    { id: "neutral", title: { ru: "Нейтральный", en: "Neutral" } }
  ]
};

// Artist info
export const artistInfo = {
  name: {
    ru: "Ирина Подлевских",
    en: "Irina Podlevskikh"
  },
  statement: {
    ru: "В моем творчестве я стремлюсь запечатлеть мгновения красоты, которые окружают нас каждый день, но часто остаются незамеченными в суете современной жизни. Для меня живопись — это способ показать зрителю мир глазами человека, умеющего удивляться и видеть необыкновенное в обычном.",
    en: "In my work, I strive to capture moments of beauty that surround us every day, but often go unnoticed in the hustle and bustle of modern life. For me, painting is a way to show the viewer the world through the eyes of a person who knows how to be amazed and see the extraordinary in the ordinary."
  },
  bio: {
    ru: "Профессиональный художник с более чем 15-летним опытом работы. Член Союза художников России. Работы находятся в частных коллекциях в России, Европе и США. Участник многочисленных выставок в России и за рубежом.",
    en: "Professional artist with over 15 years of experience. Member of the Union of Artists of Russia. Works are in private collections in Russia, Europe, and the USA. Participant in numerous exhibitions in Russia and abroad."
  },
  location: {
    ru: "Москва, Россия",
    en: "Moscow, Russia"
  },
  email: "art@ivpgallery.com",
  phone: "+7 (495) 123-45-67",
  social: {
    instagram: "https://instagram.com/ivpgallery",
    facebook: "https://facebook.com/ivpgallery",
    telegram: "https://t.me/ivpgallery"
  }
};

export default artworks;
